/**
 * Who directory search may show, as one Algolia filter string.
 *
 * The app passes it with every directory search today. It lives in a shared,
 * dependency-free package so that the API can issue the same rule inside a
 * secured search key, at which point the client no longer decides it.
 *
 * Each expert's search record carries `status` (`"1"` is Active) and
 * `awayDays`, the days of their scheduled away blocks as `YYYYMMDD` integers.
 * A day in the past simply stops matching, so nothing has to run when a block
 * starts or ends.
 */

/** `YYYY-MM-DD` to the `YYYYMMDD` integer `awayDays` holds. */
export const toAwayDayKey = (date: string): number =>
  Number(date.slice(0, 10).replaceAll("-", ""));

/**
 * The UTC calendar date of `now`, as `YYYY-MM-DD`. Away status is decided by
 * UTC date everywhere: the API's own checks use it, so the directory does too.
 */
export const utcDate = (now: Date = new Date()): string =>
  now.toISOString().slice(0, 10);

/** Leaves out an expert with a scheduled away block covering `today`. */
export const notAwayOnFilter = (today: string): string =>
  `NOT awayDays:${toAwayDayKey(today)}`;

/**
 * The experts directory search may show on `today` (UTC `YYYY-MM-DD`): Active,
 * and not in a scheduled away block that day.
 */
export const directoryVisibilityFilter = (today: string): string =>
  `status:1 AND ${notAwayOnFilter(today)}`;
